export default "__VITE_ASSET__46bab6d1__"